<template>
  <section v-if="assets">
    <h4 class="main-title">{{ t("Related_assets_label") }}</h4>
    <div id="relatedAssets" class="box mt-4">
      <div class="list-group">
        <singleRelatedItem
          v-for="assetName in assets"
          :key="assetName"
          :assetName="assetName"
          :price="quotes[assetName]"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import singleRelatedItem from "@/components/relatedAssets/singleRelatedItem";
export default {
  name: "RelatedAssets",
  props: ["assets"],
  data() {
    return {
      symbolsData: {},
      percentageData: {}
    };
  },
  components: { singleRelatedItem },
  computed: {
    ...mapState(["isLoggedIn"]),
    ...mapState("symbolsSocket", ["quotes"]),
    ...mapGetters(["t", "userLoginLink"])
  },
  methods: {
    ...mapActions(["getInfoFromWebsite"]),
    ...mapActions('symbolsSocket',['completeSocketInitialization']),
  },
  watch:{
    assets(){
      this.completeSocketInitialization(this.assets);
    }
  }
};
</script>

<style scoped>
.main-title {
  font-size: 1.25rem;
  font-weight: normal;
}

#relatedAssets .buttons .btn {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-weight: bold;
}

@media only screen and (max-width: 768px) {
  .main-title {
    font-size: 16px;
    line-height: 48px;
    background-color: #f6f6f6;
    width: 100%;
    padding-left: 15px;
  }

  #relatedAssets {
    margin-top: 0 !important;
  }
}
</style>
